module.exports = __webpack_public_path__ + "static/media/LQ_Jacquard_City Life_Bordeaux_PW Pink.c1dae02c.png";